(function () {
  'use strict';

  var STEP_ORDER = ['vehicle', 'size', 'shape', 'style', 'contact'];

  var CLOUDINARY_CLOUD_NAME = 'zkxmoooq';
  var CLOUDINARY_UPLOAD_PRESET = 'zkxmoooq';
  var CLOUDINARY_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD_NAME + '/auto/upload';
  var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
  var ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'pdf', 'svg'];

  var SIZE_DATA = {
    'car-s': { vehicle: 'car', dimensions: '30 × 15 cm' },
    'car-m': { vehicle: 'car', dimensions: '60 × 30 cm' },
    'car-l': { vehicle: 'car', dimensions: '90 × 30 cm' },
    'van-max': { vehicle: 'van', dimensions: 'Pagal mikroautobuso modelį (individualus dydis)' },
    'van-xl': { vehicle: 'van', dimensions: '120 × 30 cm' },
    'van-xl-plus': { vehicle: 'van', dimensions: '90 × 60 cm' },
    'van-xxl': { vehicle: 'van', dimensions: '140 × 30 cm' },
    'van-xxl-plus': { vehicle: 'van', dimensions: '120 × 60 cm' },
    'van-xxl-plus-plus': { vehicle: 'van', dimensions: '140 × 60 cm' },
    'custom': { vehicle: null, dimensions: null }
  };

  var SIZE_LABELS = {
    'car-s': 'S — 30 × 15 cm',
    'car-m': 'M — 60 × 30 cm',
    'car-l': 'L — 90 × 30 cm',
    'van-max': 'Magnetinės panelės MAX',
    'van-xl': 'XL — 120 × 30 cm',
    'van-xl-plus': 'XL+ — 90 × 60 cm',
    'van-xxl': 'XXL — 140 × 30 cm',
    'van-xxl-plus': 'XXL+ — 120 × 60 cm',
    'van-xxl-plus-plus': 'XXL++ — 140 × 60 cm',
    'custom': 'Nestandartinis dydis'
  };

  var VEHICLE_LABELS = { car: 'Lengvasis automobilis', van: 'Mikroautobusas' };
  var SHAPE_LABELS = { contour: 'Formuotas kontūras', rectangle: 'Stačiakampis' };
  var STYLE_LABELS = { solid: 'Solidus', illustrated: 'Su iliustracija', 'big-text': 'Didelis tekstas' };

  var STATE_FIELDS = ['businessActivity', 'mainText', 'customSize', 'phone', 'email', 'designerNotes'];

  var SHARED_PROMPT_TEMPLATE = [
    'Create an extremely high-quality, professional, print-ready advertising design for magnetic vehicle advertising.',
    'The design must be commercially usable and visually strong.',
    'Prioritize readability from 20–40 meters.',
    'Use bold typography, clear hierarchy, strong contrast, and minimal unnecessary details.',
    'Do not use clipart.',
    'Do not use cheap stock-style graphics.',
    'Do not use watermarks.',
    'Do not use thin hard-to-read fonts.',
    'Do not add random text.',
    'Do not invent contact details.',
    'Do not change the supplied phone number, brand name, URL, or required wording.',
    'Avoid visual clutter.',
    'Keep the design suitable for professional printing and contour cutting.',
    'Use vector-style quality wherever possible.',
    'Ensure clean edges, balanced spacing, and a professional commercial composition.',
    'The physical format is {DIMENSIONS}.',
    'The selected shape is {SHAPE}.',
    'The selected style is {STYLE}.',
    'The business activity is {BUSINESS_ACTIVITY}.',
    'The main and largest text is {MAIN_TEXT}.',
    'The phone number is {PHONE}.',
    'Additional client instructions: {NOTES}.'
  ].join('\n\n');

  var STYLE_EXTENSIONS = {
    solid: [
      'Use a premium, clean, minimalist business style.',
      'Create a serious and trustworthy visual identity.',
      'Use generous whitespace.',
      'Prioritize the company name or logo, the main service text, and the phone number.',
      'Use a restrained number of elements.',
      'Do not use illustrations unless absolutely necessary.',
      'Do not use decorative icon collections.',
      'Use strong but elegant typography.',
      'The final result should look like professional branding, not a promotional flyer.'
    ].join('\n\n'),
    illustrated: [
      'Use one high-quality custom animated or vector-style illustration related to the client’s activity.',
      'The illustration must feel modern, professional, expressive, and commercially designed.',
      'Do not use clipart.',
      'Do not use a collage of unrelated icons.',
      'Use one dominant visual scene or character.',
      'Combine the illustration with bold modern typography.',
      'Add a clear call icon next to the phone number.',
      'Keep the main message readable from a distance.',
      'The illustration must support the service and must not overpower the key text.'
    ].join('\n\n'),
    'big-text': [
      'Make the main text the dominant design element.',
      'Use extremely large, bold, modern typography.',
      'Keep the wording short and instantly readable.',
      'Use only one supporting vector symbol representing the activity.',
      'Avoid unnecessary decoration.',
      'If the selected shape is contour, make the outer cut contour follow the dominant text and core visual silhouette.',
      'If the selected shape is rectangular, use the full surface area efficiently.',
      'The final design must be readable within approximately one second.'
    ].join('\n\n')
  };

  var CONCEPT_LINES = {
    solid: {
      A: 'Concept direction: the most minimal composition, with the strongest logo or company-name focus.',
      B: 'Concept direction: stronger typography with a slightly more dynamic composition.',
      C: 'Concept direction: the strongest premium contrast with a highly structured contact hierarchy.'
    },
    illustrated: {
      A: 'Concept direction: character-led illustration with a clear service action.',
      B: 'Concept direction: equipment or work-process illustration with a stronger commercial composition.',
      C: 'Concept direction: symbolic activity illustration, the simplest and most readable version.'
    },
    'big-text': {
      A: 'Concept direction: typography occupies most of the design.',
      B: 'Concept direction: typography plus one strong activity symbol.',
      C: 'Concept direction: the widest and simplest distance-readable layout.'
    }
  };

  function createInitialState() {
    return {
      vehicle: null,
      size: null,
      customSize: '',
      shape: null,
      style: null,
      businessActivity: '',
      mainText: '',
      phone: '',
      email: '',
      designerNotes: '',
      attachments: []
    };
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- Phone normalization ---------- */

  function normalizePhone(rawValue) {
    var trimmed = (rawValue || '').trim();
    if (!trimmed) return trimmed;

    var digitsOnly = trimmed.replace(/\D/g, '');
    var national = null;

    if (trimmed.indexOf('+370') === 0 && digitsOnly.length === 11) {
      national = '0' + digitsOnly.slice(3);
    } else if (digitsOnly.indexOf('370') === 0 && digitsOnly.length === 11) {
      national = '0' + digitsOnly.slice(3);
    } else if (digitsOnly.indexOf('0') === 0 && digitsOnly.length === 9) {
      national = digitsOnly;
    } else if (digitsOnly.length === 8 && digitsOnly.indexOf('6') === 0) {
      national = '0' + digitsOnly;
    }

    if (national && /^06\d{7}$/.test(national)) {
      return national.slice(0, 3) + ' ' + national.slice(3, 6) + ' ' + national.slice(6, 9);
    }

    return trimmed;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
  }

  function isPlausiblePhone(rawValue) {
    var trimmed = (rawValue || '').trim();
    if (!trimmed) return false;
    var normalized = normalizePhone(trimmed);
    if (/^\d{3} \d{3} \d{3}$/.test(normalized)) return true;
    return trimmed.replace(/\D/g, '').length >= 7;
  }

  /* ---------- AI design brief + prompts ---------- */

  function getDimensionsText(state) {
    if (state.size === 'custom') {
      return state.customSize ? state.customSize.trim() : 'Nestandartinis dydis (nurodytas kliento)';
    }
    var data = SIZE_DATA[state.size];
    return data ? data.dimensions : '';
  }

  function fillTemplate(template, state) {
    var notes = state.designerNotes && state.designerNotes.trim()
      ? state.designerNotes.trim()
      : 'No additional client instructions were provided.';

    return template
      .replace('{DIMENSIONS}', getDimensionsText(state))
      .replace('{SHAPE}', SHAPE_LABELS[state.shape] || state.shape || '')
      .replace('{STYLE}', STYLE_LABELS[state.style] || state.style || '')
      .replace('{BUSINESS_ACTIVITY}', state.businessActivity || '')
      .replace('{MAIN_TEXT}', state.mainText || '')
      .replace('{PHONE}', normalizePhone(state.phone) || state.phone || '')
      .replace('{NOTES}', notes);
  }

  function buildPromptVariants(state) {
    var base = fillTemplate(SHARED_PROMPT_TEMPLATE, state);
    var extension = STYLE_EXTENSIONS[state.style] || '';
    var concepts = CONCEPT_LINES[state.style] || { A: '', B: '', C: '' };

    function variant(letter) {
      return [base, extension, concepts[letter]].filter(Boolean).join('\n\n');
    }

    return { A: variant('A'), B: variant('B'), C: variant('C') };
  }

  function buildDesignBrief(state) {
    var focalPoint;
    if (state.style === 'big-text') {
      focalPoint = 'Pagrindinis tekstas užima didžiąją dizaino dalį.';
    } else if (state.style === 'illustrated') {
      focalPoint = 'Dominuojanti iliustracija kartu su pagrindiniu tekstu.';
    } else {
      focalPoint = 'Įmonės pavadinimas / logotipas ir pagrindinė žinutė.';
    }

    var composition = state.shape === 'contour'
      ? 'Kompozicija pritaikyta prie formuoto kontūro, sekančio dizaino siluetą.'
      : 'Kompozicija, išnaudojanti visą stačiakampį plotą.';

    var cutContour = state.shape === 'contour'
      ? 'Kontūras pjaunamas pagal pagrindinio teksto ir vizualinio elemento siluetą.'
      : 'Standartinis stačiakampis pjovimas, išnaudojant visą turimą plotą.';

    var readabilityRisk = (state.mainText || '').trim().length > 20
      ? 'Vidutinė — ilgesnis pagrindinis tekstas gali sumažinti skaitomumą iš toli.'
      : 'Žema — trumpas ir aiškus pagrindinis tekstas gerai skaitomas iš toli.';

    return [
      'Advertising goal: Pritraukti dėmesį ir paskatinti susisiekti dėl „' + (state.businessActivity || '') + '“ paslaugų.',
      'Primary message: ' + (state.mainText || ''),
      'Secondary message: Telefono numeris ir kontaktinė informacija.',
      'Recommended focal point: ' + focalPoint,
      'Recommended composition: ' + composition,
      'Recommended contrast: Aukštas kontrastas gerai matomumui iš 20–40 metrų atstumo.',
      'Recommended cut contour approach: ' + cutContour,
      'Readability risk: ' + readabilityRisk
    ].join('\n');
  }

  /* ---------- Contact form body (Shopify's native "message" field) ---------- */

  function buildContactBody(state, prompts, brief, fileUrls) {
    var lines = [
      'NAUJA STARBER UŽKLAUSA',
      '',
      'KLIENTO PASIRINKIMAI',
      '',
      'Transportas: ' + (VEHICLE_LABELS[state.vehicle] || ''),
      'Dydis: ' + (SIZE_LABELS[state.size] || '')
    ];

    if (state.size === 'custom') {
      lines.push('Nestandartinis dydis: ' + (state.customSize || ''));
    }

    lines.push(
      'Forma: ' + (SHAPE_LABELS[state.shape] || ''),
      'Stilius: ' + (STYLE_LABELS[state.style] || ''),
      '',
      'KLIENTO INFORMACIJA',
      '',
      'Veikla: ' + (state.businessActivity || ''),
      'Didžiausias tekstas: ' + (state.mainText || ''),
      'Telefonas: ' + (normalizePhone(state.phone) || ''),
      'El. paštas: ' + (state.email || ''),
      'Pageidavimai dizaineriui: ' + (state.designerNotes || '—'),
      '',
      'FAILAI',
      '',
      fileUrls && fileUrls.length ? fileUrls.join('\n') : 'Failų nepridėta.',
      '',
      'AI DESIGN BRIEF',
      '',
      brief,
      '',
      'AI PROMPT — VARIANT A',
      '',
      prompts.A,
      '',
      'AI PROMPT — VARIANT B',
      '',
      prompts.B,
      '',
      'AI PROMPT — VARIANT C',
      '',
      prompts.C
    );

    return lines.join('\n');
  }

  /* ---------- Session persistence ---------- */

  function sessionKey(root) {
    return 'starberConfiguratorState:' + root.id;
  }

  function saveStateToSession(root, state) {
    try {
      var persisted = {
        vehicle: state.vehicle,
        size: state.size,
        customSize: state.customSize,
        shape: state.shape,
        style: state.style,
        businessActivity: state.businessActivity,
        mainText: state.mainText,
        designerNotes: state.designerNotes
      };
      window.sessionStorage.setItem(sessionKey(root), JSON.stringify(persisted));
    } catch (e) {
      /* sessionStorage unavailable — ignore */
    }
  }

  function loadStateFromSession(root) {
    try {
      var raw = window.sessionStorage.getItem(sessionKey(root));
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  /* ---------- Rendering helpers ---------- */

  function updateProgress(root, state) {
    var stepComplete = {
      vehicle: !!state.vehicle,
      size: !!state.size,
      shape: !!state.shape,
      style: !!state.style,
      contact: false
    };

    var currentStep = STEP_ORDER.filter(function (step) { return !stepComplete[step]; })[0] || 'contact';

    var items = root.querySelectorAll('[data-progress-step]');
    items.forEach(function (item) {
      var step = item.getAttribute('data-progress-step');
      item.classList.remove('is-complete', 'is-current', 'is-upcoming');
      if (stepComplete[step]) {
        item.classList.add('is-complete');
        item.removeAttribute('aria-current');
      } else if (step === currentStep) {
        item.classList.add('is-current');
        item.setAttribute('aria-current', 'step');
      } else {
        item.classList.add('is-upcoming');
        item.removeAttribute('aria-current');
      }
    });
  }

  function scrollToStep(root, stepName) {
    var section = root.querySelector('[data-step-section="' + stepName + '"]');
    if (!section) return;
    section.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function showStep(root, stepName) {
    var section = root.querySelector('[data-step-section="' + stepName + '"]');
    if (!section) return;
    var wasHidden = section.hasAttribute('hidden');
    if (wasHidden) {
      section.removeAttribute('hidden');
      scrollToStep(root, stepName);
    }
  }

  function setCardSelected(root, step, value) {
    var cards = root.querySelectorAll('[data-starber-card][data-step="' + step + '"]');
    cards.forEach(function (card) {
      var isMatch = card.getAttribute('data-value') === value;
      card.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
    });
  }

  function renderSizeOptions(root, vehicle) {
    var carGroup = root.querySelector('[data-size-group="car"]');
    var vanGroup = root.querySelector('[data-size-group="van"]');
    if (carGroup) carGroup.hidden = vehicle !== 'car';
    if (vanGroup) vanGroup.hidden = vehicle !== 'van';
  }

  function toggleCustomSizeField(root, state) {
    var field = root.querySelector('[data-custom-size-field]');
    if (!field) return;
    var show = state.size === 'custom';
    field.hidden = !show;
    var input = field.querySelector('[data-field="customSize"]');
    if (input) {
      input.required = show;
      input.disabled = !show;
    }
  }

  /* ---------- Selection handlers ---------- */

  function selectVehicle(root, state, value) {
    var changed = state.vehicle !== value;
    state.vehicle = value;
    setCardSelected(root, 'vehicle', value);
    renderSizeOptions(root, value);

    if (changed) {
      state.size = null;
      state.customSize = '';
      setCardSelected(root, 'size', null);
      toggleCustomSizeField(root, state);
      var customSizeInput = root.querySelector('[data-field="customSize"]');
      if (customSizeInput) customSizeInput.value = '';
    }

    updateProgress(root, state);
    saveStateToSession(root, state);
    syncHiddenContactFields(root, state);
    showStep(root, 'size');
  }

  function selectSize(root, state, value) {
    state.size = value;
    if (value !== 'custom') {
      state.customSize = '';
      var input = root.querySelector('[data-field="customSize"]');
      if (input) input.value = '';
    }
    setCardSelected(root, 'size', value);
    toggleCustomSizeField(root, state);
    updateProgress(root, state);
    saveStateToSession(root, state);
    syncHiddenContactFields(root, state);
    showStep(root, 'shape');
  }

  function selectShape(root, state, value) {
    state.shape = value;
    setCardSelected(root, 'shape', value);
    updateProgress(root, state);
    saveStateToSession(root, state);
    syncHiddenContactFields(root, state);
    showStep(root, 'style');
  }

  function selectStyle(root, state, value) {
    state.style = value;
    setCardSelected(root, 'style', value);
    updateProgress(root, state);
    saveStateToSession(root, state);
    syncHiddenContactFields(root, state);
    showStep(root, 'contact');
  }

  /* ---------- File uploads (Cloudinary, unsigned) ---------- */

  function formatFileSize(bytes) {
    if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function fileExtension(name) {
    var parts = name.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
  }

  function getUploadedFileUrls(state) {
    return state.attachments
      .filter(function (entry) { return entry.status === 'done' && entry.url; })
      .map(function (entry) { return entry.url; });
  }

  function renderFileList(root, state) {
    var list = root.querySelector('[data-starber-filelist]');
    if (!list) return;
    list.innerHTML = '';
    state.attachments.forEach(function (entry, index) {
      var li = document.createElement('li');
      li.setAttribute('data-upload-state', entry.status);

      var statusText = entry.status === 'uploading'
        ? ' — įkeliama...'
        : entry.status === 'error'
          ? ' — nepavyko įkelti'
          : '';

      var label = document.createElement('span');
      label.textContent = entry.file.name + ' (' + formatFileSize(entry.file.size) + ')' + statusText;
      li.appendChild(label);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.textContent = 'Pašalinti';
      removeBtn.setAttribute('aria-label', 'Pašalinti failą ' + entry.file.name);
      removeBtn.addEventListener('click', function () {
        state.attachments.splice(index, 1);
        syncFileInput(root, state);
        renderFileList(root, state);
        syncHiddenContactFields(root, state);
      });
      li.appendChild(removeBtn);

      list.appendChild(li);
    });
  }

  function syncFileInput(root, state) {
    var input = root.querySelector('input[name="attachments"]');
    if (!input || typeof DataTransfer === 'undefined') return;
    var dataTransfer = new DataTransfer();
    state.attachments.forEach(function (entry) { dataTransfer.items.add(entry.file); });
    input.files = dataTransfer.files;
  }

  function uploadSingleFile(file) {
    var formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    return fetch(CLOUDINARY_UPLOAD_URL, { method: 'POST', body: formData })
      .then(function (response) {
        if (!response.ok) throw new Error('Cloudinary upload failed for ' + file.name);
        return response.json();
      })
      .then(function (data) { return data.secure_url; });
  }

  function handleFileInputChange(root, state, input) {
    var errorEl = root.querySelector('[data-error-for="attachments"]');
    var rejected = [];
    var accepted = [];

    Array.prototype.forEach.call(input.files, function (file) {
      var ext = fileExtension(file.name);
      if (ALLOWED_EXTENSIONS.indexOf(ext) === -1) {
        rejected.push(file.name + ' — netinkamas failo tipas.');
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        rejected.push(file.name + ' — viršija 10 MB dydžio limitą.');
        return;
      }
      var alreadyAdded = state.attachments.some(function (entry) {
        return entry.file.name === file.name && entry.file.size === file.size;
      });
      if (!alreadyAdded) accepted.push({ file: file, url: null, status: 'uploading' });
    });

    state.attachments = state.attachments.concat(accepted);
    syncFileInput(root, state);
    renderFileList(root, state);
    syncHiddenContactFields(root, state);

    if (errorEl) {
      if (rejected.length) {
        errorEl.textContent = rejected.join(' ');
        errorEl.hidden = false;
      } else {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }

    // Upload immediately on selection — not deferred until submit — so the
    // Cloudinary URL is already sitting in the hidden field well before the
    // customer clicks submit. Shopify's own contact-form bot protection can
    // trigger its own near-instant submission once solved, which otherwise
    // races an upload-then-submit chain started only at click time.
    accepted.forEach(function (entry) {
      uploadSingleFile(entry.file)
        .then(function (url) {
          entry.url = url;
          entry.status = 'done';
          renderFileList(root, state);
          syncHiddenContactFields(root, state);
        })
        .catch(function () {
          entry.status = 'error';
          renderFileList(root, state);
          if (errorEl) {
            errorEl.textContent = entry.file.name + ' — nepavyko įkelti. Pašalinkite ir bandykite dar kartą.';
            errorEl.hidden = false;
          }
        });
    });
  }

  /* ---------- Validation ---------- */

  function setFieldError(root, fieldName, message) {
    var input = root.querySelector('[data-field="' + fieldName + '"]');
    var errorEl = root.querySelector('[data-error-for="' + fieldName + '"]');

    if (input) input.classList.add('is-invalid');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
    return input;
  }

  function clearFieldErrors(root) {
    root.querySelectorAll('.starber-field__error').forEach(function (el) {
      el.textContent = '';
      el.hidden = true;
    });
    root.querySelectorAll('.is-invalid').forEach(function (el) {
      el.classList.remove('is-invalid');
    });
  }

  function setStatus(root, state_, message) {
    var statusEl = root.querySelector('[data-starber-status]');
    if (!statusEl) return;
    statusEl.textContent = message;
    statusEl.setAttribute('data-state', state_);
    statusEl.hidden = !message;
  }

  function validateForm(root, state) {
    clearFieldErrors(root);
    setStatus(root, '', '');

    if (!state.vehicle || !state.size || !state.shape || !state.style) {
      var missingStep = !state.vehicle ? 'vehicle' : (!state.size ? 'size' : (!state.shape ? 'shape' : 'style'));
      setStatus(root, 'error', 'Prašome užpildyti visus ankstesnius žingsnius.');
      scrollToStep(root, missingStep);
      return false;
    }

    var firstInvalid = null;

    if (!state.businessActivity || !state.businessActivity.trim()) {
      var businessInput = setFieldError(root, 'businessActivity', 'Įveskite veiklos sritį.');
      firstInvalid = firstInvalid || businessInput;
    }
    if (!state.mainText || !state.mainText.trim()) {
      var mainTextInput = setFieldError(root, 'mainText', 'Įveskite pagrindinį reklamos tekstą.');
      firstInvalid = firstInvalid || mainTextInput;
    }
    if (state.size === 'custom' && (!state.customSize || !state.customSize.trim())) {
      var customSizeInput = setFieldError(root, 'customSize', 'Nurodykite reikalingą dydį.');
      firstInvalid = firstInvalid || customSizeInput;
    }
    if (!isPlausiblePhone(state.phone)) {
      var phoneInvalidInput = setFieldError(root, 'phone', 'Įveskite teisingą telefono numerį.');
      firstInvalid = firstInvalid || phoneInvalidInput;
    }
    if (!isValidEmail(state.email)) {
      var emailInvalidInput = setFieldError(root, 'email', 'Įveskite teisingą el. pašto adresą.');
      firstInvalid = firstInvalid || emailInvalidInput;
    }

    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
      firstInvalid.focus();
      return false;
    }

    return true;
  }

  /* ---------- Submission ---------- */

  function setNamedField(root, name, value) {
    var input = root.querySelector('[name="' + name + '"]');
    if (input) input.value = value;
  }

  function populateHiddenContactFields(root, state) {
    var prompts = buildPromptVariants(state);
    var brief = buildDesignBrief(state);
    var fileUrls = getUploadedFileUrls(state);

    setNamedField(root, 'contact[name]', state.businessActivity || 'STARBER klientas');
    setNamedField(root, 'contact[Transportas]', VEHICLE_LABELS[state.vehicle] || '');
    setNamedField(root, 'contact[Dydis]', SIZE_LABELS[state.size] || '');
    setNamedField(root, 'contact[Forma]', SHAPE_LABELS[state.shape] || '');
    setNamedField(root, 'contact[Stilius]', STYLE_LABELS[state.style] || '');
    setNamedField(root, 'contact[Failų nuorodos]', fileUrls.length ? fileUrls.join('\n') : '');
    setNamedField(root, 'contact[AI Design Brief]', brief);
    setNamedField(root, 'contact[AI Promptas A]', prompts.A);
    setNamedField(root, 'contact[AI Promptas B]', prompts.B);
    setNamedField(root, 'contact[AI Promptas C]', prompts.C);
    setNamedField(root, 'contact[body]', buildContactBody(state, prompts, brief, fileUrls));
  }

  function syncHiddenContactFields(root, state) {
    // Called after every selection, keystroke, and file upload completion so the
    // hidden contact[...] fields (including file URLs) are already correct well
    // before the customer reaches submit — not computed only at click time. This
    // matters because Shopify's own bot-protection (hCaptcha) can trigger its own
    // near-instant form submission once solved, racing anything deferred until
    // the submit handler runs.
    populateHiddenContactFields(root, state);
  }

  function submitForm(root, state, form, event) {
    event.preventDefault();

    if (root.dataset.starberSubmitting === 'true') return;
    if (!validateForm(root, state)) return;

    var stillUploading = state.attachments.some(function (entry) { return entry.status === 'uploading'; });
    if (stillUploading) {
      setStatus(root, 'error', 'Palaukite, kol failai bus įkelti, ir bandykite dar kartą.');
      return;
    }

    var hasFailedUpload = state.attachments.some(function (entry) { return entry.status === 'error'; });
    if (hasFailedUpload) {
      setStatus(root, 'error', 'Vieno ar kelių failų įkelti nepavyko. Pašalinkite juos arba bandykite iš naujo.');
      return;
    }

    // Files (if any) are already uploaded — populate synchronously and submit
    // immediately, with no async gap where a race could leave fields stale.
    populateHiddenContactFields(root, state);

    var submitBtn = root.querySelector('[data-starber-submit]');
    var submitLabel = root.querySelector('[data-starber-submit-label]');
    var fileInput = root.querySelector('input[name="attachments"]');

    root.dataset.starberSubmitting = 'true';
    if (submitBtn) submitBtn.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Siunčiama...';
    setStatus(root, '', '');

    // The raw file input must not be part of the native Shopify submission —
    // files are already uploaded to Cloudinary and referenced via URL above.
    if (fileInput) fileInput.disabled = true;
    form.submit();
  }

  /* ---------- Session restore ---------- */

  function restoreFromSession(root, state) {
    var saved = loadStateFromSession(root);
    if (!saved) return;

    Object.assign(state, saved);

    if (state.vehicle) {
      setCardSelected(root, 'vehicle', state.vehicle);
      renderSizeOptions(root, state.vehicle);
      showStep(root, 'size');
    }
    if (state.size) {
      setCardSelected(root, 'size', state.size);
      toggleCustomSizeField(root, state);
      var customInput = root.querySelector('[data-field="customSize"]');
      if (customInput) customInput.value = state.customSize || '';
      showStep(root, 'shape');
    }
    if (state.shape) {
      setCardSelected(root, 'shape', state.shape);
      showStep(root, 'style');
    }
    if (state.style) {
      setCardSelected(root, 'style', state.style);
      showStep(root, 'contact');
    }

    STATE_FIELDS.forEach(function (fieldName) {
      if (fieldName === 'customSize') return;
      var input = root.querySelector('[data-field="' + fieldName + '"]');
      if (input && state[fieldName]) input.value = state[fieldName];
    });

    updateProgress(root, state);
    syncHiddenContactFields(root, state);
  }

  /* ---------- Init ---------- */

  function setupInstance(root) {
    if (root.dataset.starberInitialized === 'true') return;
    root.dataset.starberInitialized = 'true';
    root.dataset.starberSubmitting = 'false';

    var state = createInitialState();
    var form = root.querySelector('form');
    if (!form) return;

    restoreFromSession(root, state);

    root.addEventListener('click', function (event) {
      var card = event.target.closest('[data-starber-card]');
      if (!card || !root.contains(card)) return;

      var step = card.getAttribute('data-step');
      var value = card.getAttribute('data-value');

      if (step === 'vehicle') selectVehicle(root, state, value);
      else if (step === 'size') selectSize(root, state, value);
      else if (step === 'shape') selectShape(root, state, value);
      else if (step === 'style') selectStyle(root, state, value);
    });

    form.addEventListener('input', function (event) {
      var target = event.target;
      var stateKey = target.getAttribute('data-field');
      if (!stateKey || STATE_FIELDS.indexOf(stateKey) === -1) return;

      state[stateKey] = target.value;
      target.classList.remove('is-invalid');
      var errorEl = root.querySelector('[data-error-for="' + stateKey + '"]');
      if (errorEl) errorEl.hidden = true;
      saveStateToSession(root, state);
      syncHiddenContactFields(root, state);
    });

    var fileInput = root.querySelector('input[name="attachments"]');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        handleFileInputChange(root, state, fileInput);
      });
    }

    var phoneInput = root.querySelector('[data-field="phone"]');
    if (phoneInput) {
      phoneInput.addEventListener('blur', function () {
        if (!phoneInput.value.trim()) return;
        var normalized = normalizePhone(phoneInput.value);
        phoneInput.value = normalized;
        state.phone = normalized;
      });
    }

    form.addEventListener('submit', function (event) {
      submitForm(root, state, form, event);
    });
  }

  function initConfigurator() {
    document.querySelectorAll('[data-starber-configurator]').forEach(setupInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConfigurator);
  } else {
    initConfigurator();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-starber-configurator]');
    if (root) setupInstance(root);
  });
})();
